import React, { useState, useEffect } from 'react'
import { ccpProvider } from 'core/CcpProvider'
import { T } from 'components/misc'
import SystemMessage from './SystemMessage'

const Loader = ({ size }) => (
  <div style={{height: `${size}px`}} className="loader__container">
    <span style={{height: `${size - 5}px`, width: `${size - 5}px`}} className="loader"/>
  </div>
)

const MessageRebill = props => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)

  const onClick = e => {
    e.preventDefault()
    setLoading(true)
    setError(false)
    ccpProvider.api.user.enableRecurring({ conversationUid: props.conversationUid }).then(([, err]) => {
      setLoading(false)
      setSuccess(!err)
      setError(!!err)
    })
  }
  return loading ? <MessageRebillProcessing/> : success ? <MessageRebillEnabled {...props}/> : <MessageRebillWarning error={error} onClick={onClick}/>
}

const MessageRebillProcessing = () => (
  <SystemMessage title="warning">
    <Loader size="30"/>
    <p><T>recurringNotification.processing</T></p>
  </SystemMessage>
)

const MessageRebillEnabled = ({ rebillSucceeded }) => {
  const REBILL_SUCCEEDED_AFTER = 5000 // 5 seconds

  useEffect(() => {
    setTimeout(rebillSucceeded, REBILL_SUCCEEDED_AFTER)
  }, [])

  return <SystemMessage type="success" title="congratulations" text="recurringNotification.success"/>
}

const MessageRebillWarning = ({ onClick, error }) => (
  <SystemMessage
    title="warning"
    text={`recurringNotification.${error ? 'error' : 'default'}`}
    upgradeLink={(linkText, key) => <a key={key} className="system-message__body__link--inline" href="#" onClick={onClick}>{linkText}</a>}/>
)

export default MessageRebill
